// node_modules
import React from 'react'
import styled from 'styled-components'
import { PageProps, graphql } from 'gatsby'
// types
// assets
// styles
import media from 'styles/media'
// utils
// hooks
// components
import { Layout } from 'views/Layout'
import {
  BodyLarge,
  H500,
  H600,
  H800,
  H900,
  Subtitle,
  SubtitleL,
  Text,
} from 'components/atoms/Typography'
import { Seo } from 'components/atoms/Seo'

const Wrapper = styled.div`
  padding: 32px 20px;

  ${media.xl.min} {
    padding: 72px 48px;
  }

  ${media.huge.min} {
    padding: 96px 48px;
  }
`

const InnerWarpper = styled.div`
  max-width: 700px;

  margin: 0px auto;

  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const Hr = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${({ theme }) =>
    theme.accessibilityCollors
      ? theme.colors.accessibility.yellow
      : theme.colors.black};
`

const PrivacyContent = styled.div`
  ${BodyLarge}

  ${media.lg.min} {
    ${Subtitle}
  }

  & strong {
    padding-bottom: 16px;
    padding-top: 40px;

    display: block;

    color: ${({ theme }) => theme.colors.fonts.black};

    ${H500}

    ${media.lg.min} {
      ${H600}
    }
  }

  & p {
    ${BodyLarge}

    color: ${({ theme }) => theme.colors.fonts.black};

    ${media.lg.min} {
      ${Subtitle}
    }
  }

  & ol {
    color: ${({ theme }) => theme.colors.fonts.black};

    margin-bottom: 0px;
  }

  & li {
    margin-bottom: 2px;

    color: ${({ theme }) => theme.colors.fonts.black};

    ${BodyLarge}

    ${media.lg.min} {
      ${Subtitle}
    }
  }

  & ul {
    margin: 0px;
    margin-left: 24px;

    color: ${({ theme }) => theme.colors.fonts.black};

    list-style-type: disc;
  }
`

const PrivacyPolicyPage: React.FC<
  PageProps<Queries.PrivacyPolicyPageQuery>
> = ({ data }) => {
  const PAGE = data.wpPage?.privacypolicy
  const PAGE_SEO = data.wpPage?.seo!

  if (!PAGE || !PAGE_SEO)
    throw new Error("PrivacyPolicyPage: CMS data didn't load properly")

  return (
    <Layout headerSecoundary>
      <Seo
        title={PAGE_SEO.title ?? ''}
        description={PAGE_SEO.metaDesc ?? ''}
        ogTitle={PAGE_SEO.opengraphTitle}
        ogDescription={PAGE_SEO.opengraphDescription}
        ogImage={PAGE_SEO.opengraphImage?.sourceUrl}
        twitterTitle={PAGE_SEO.twitterTitle}
        twitterDescription={PAGE_SEO.twitterDescription}
        twitterImage={PAGE_SEO.twitterImage?.sourceUrl}
      />

      <Wrapper>
        <InnerWarpper>
          <Header>
            <Text
              as="h1"
              mobile={H800}
              desktop={H900}
              dangerouslySetInnerHTML={{ __html: 'Polityka prywatności' }}
            />
            <Hr />
            <Text
              mobile={Subtitle}
              desktop={SubtitleL}
              dangerouslySetInnerHTML={{
                __html:
                  'Polityka prywatności opisuje zasady przetwarzania przez nas informacji na Twój temat, w tym danych osobowych oraz ciasteczek, czyli tzw. cookies.',
              }}
            />
          </Header>

          <PrivacyContent
            dangerouslySetInnerHTML={{
              __html: data.wpPage?.privacypolicy?.poleTresci!,
            }}
          />
        </InnerWarpper>
      </Wrapper>
    </Layout>
  )
}

export default PrivacyPolicyPage

export const query = graphql`
  query PrivacyPolicyPage {
    wpPage(slug: { regex: "/polityka-prywatnosci/" }) {
      seo {
        ...WpSEO
      }
      privacypolicy {
        poleTresci
      }
    }
  }
`
